export default __webpack_public_path__ + "static/media/bomb-diagonal-3.b8bb7b81.svg";